import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useCompositionsContext } from "../context/CompositionsContext";
import EncryptionContext from "config/context/encryptionContext";
import { useCompositionAdvancedOptionsContext } from "../context/CompositionAdvancedOptionsContext";

export const useReadComposition = () => {
    const { encryption } = useContext(EncryptionContext);
    const { setSelectedComposition, selectedComposition, startLoading, stopLoading } = useCompositionsContext();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { limit, localLimit, setNextKey, setPrevKey, query, localQuery, sortBy, operator, reverse, localReverse } = useCompositionAdvancedOptionsContext();

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const readComposition = async ({
        composition,
        offset = 0,
    }) => {
        setLoading(true);
        startLoading('readComposition');
        try {
            const combinedQuery = { ...(query || {}) };
            if (localQuery && typeof localQuery === 'object') {
                const keys = Object.keys(localQuery);
                if (keys.length > 0) {
                    const k0 = keys[0];
                    const primaryQuery = combinedQuery[k0] || {};
                    const { min = null, max = null } = localQuery[k0] || {};
                    combinedQuery[k0] = { ...(primaryQuery), min: primaryQuery.min > min || min === null ? primaryQuery.min : min, max: primaryQuery.max < max || max === null ? primaryQuery.max : max };
                }
            }
            const res = await fetch(`${URL}/api/database/read`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                    scope: selectedComposition?.selected_scope || selectedAccount || "",
                    composition: composition,
                    query: combinedQuery,
                    reverse: reverse ^ localReverse,
                    limit: (localLimit && (limit || 12) > localLimit) ? localLimit : (limit || 12),
                    // offset: offset, // count % limit
                    sort_by: sortBy,
                    operator: operator || "||",
                    encryption: encryption || false,
                    encryption_key: "",
                }),
            });

            const data = await res.json();
            setResponse(data);
            if (data?.status && data?.rows) {
                setSelectedComposition(prev => ({
                    ...prev,
                    rows: data.rows || prev.rows || [],
                    count: Number.isFinite(data.count) ? data.count : (Array.isArray(data.rows) ? data.rows.length : prev.count),
                }))
                if (localReverse) {
                    setPrevKey(data?.next_value);
                } else {
                    setNextKey(data?.next_value);
                }
            }
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
            stopLoading('readComposition');
        }
    }

    return {
        response,
        loading,
        error,
        readComposition
    }
}